import { render, staticRenderFns } from "./PendingDeliveriesTable.vue?vue&type=template&id=34a0c28f&scoped=true"
import script from "./PendingDeliveriesTable.vue?vue&type=script&lang=js"
export * from "./PendingDeliveriesTable.vue?vue&type=script&lang=js"
import style0 from "./PendingDeliveriesTable.vue?vue&type=style&index=0&id=34a0c28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0c28f",
  null
  
)

export default component.exports